module.exports = __webpack_public_path__ + "static/img/yeswecan0023.1025050.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0023.png
// module id = 589
// module chunks = 1